export const disableCustomerAction = (customerId)=>{
    return {type:"DISABLE_CUSTOMER_ACTION",payload:customerId}
}

export const disableCustomerData = (message)=>{
    return {type:"DISABLE_CUSTOMER_DATA",payload:message}
}